<template>
  <!-- Ya no genera PDF aquí; solo aloja el modal de vista previa, que es
       el que decide si se manda a imprimir. -->
  <div>
    <TicketPreview ref="preview" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import axiosAdelaService from '@/axios/axiosAdelaService'
import TicketPreview from './TicketPreview.vue'
moment().tz('America/Mexico_city').format()

export default {
  props: ['ticket', 'enterprise', 'print'],
  components: {
    TicketPreview
  },
  data () {
    return {
      footer: [],
      totalProductos: 0,
      ultimaVenta: [],
      ultimaVentaReales: []
    }
  },
  watch: {
    print () {
      this.getSale(this.ticket)
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async getSale (invoice) {
      this.ultimaVenta = []
      this.totalProductos = 0
      const request = {
        invoice: invoice,
        id_empresa: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getLastSales', request)
      if (response.status === 200) {
        this.ultimaVenta = response.data
        const abonos = this.ultimaVenta.abonos
        this.ultimaVentaReales = response.data.reales

        let totalVenta = 0
        let descuento = 0
        let quantityProdcuts = 0
        for (const key in this.ultimaVenta.rows) {
          totalVenta += this.ultimaVenta.rows[key].quantity * this.ultimaVenta.rows[key].precio
          descuento += this.ultimaVenta.rows[key].descuento2 === null
            ? (this.ultimaVenta.rows[key].quantity * this.ultimaVenta.rows[key].descuento)
            : this.ultimaVenta.rows[key].descuento2
          quantityProdcuts += this.ultimaVenta.rows[key].quantity
        }
        this.ultimaVenta.quantityProdcuts = quantityProdcuts
        this.ultimaVentaReales.totalCompra = totalVenta

        await this.verifyStatusAbono(abonos)

        const payload = this.armarPayload({
          totalVentaRaw: totalVenta,
          descuentoRaw: descuento,
          totalRaw: totalVenta - descuento
        })
        this.$refs.preview.mostrar(payload)
      }
    },

    armarPayload ({ totalVentaRaw, descuentoRaw, totalRaw }) {
      const r = this.ultimaVentaReales
      const pagos = []

      if (r.efectivo > 0) {
        const efectivoCobrado = r.total - r.totalAbonos - r.transferencia - r.tarjeta + r.comision
        pagos.push({ concepto: 'Pago en Efectivo', monto: efectivoCobrado })
      }
      if (r.transferencia > 0) pagos.push({ concepto: 'Pago con transferencia', monto: r.transferencia })
      if (r.tarjeta > 0) pagos.push({ concepto: 'Pago con tarjeta', monto: r.tarjeta })
      if (r.comision > 0) pagos.push({ concepto: 'Comisión', monto: r.comision })
      if (r.efectivo > 0) pagos.push({ concepto: 'Efectivo recibido', monto: r.efectivo })
      if (r.cambio > 0) pagos.push({ concepto: 'Cambio', monto: r.cambio })
      ;(this.ultimaVenta.abonos || []).forEach((abono) => {
        pagos.push({ concepto: `Nota ${abono.type}`, monto: abono.amount })
      })
      ;(this.ultimaVenta.devoluciones || []).forEach((dev) => {
        pagos.push({ concepto: `Vale ${dev.barcode}`, monto: dev.amount })
      })

      const extras = []
      if (r.totalNotas > 0) extras.push({ concepto: 'Notas', monto: r.totalNotas })
      if (r.total_cancelaciones > 0) extras.push({ concepto: 'Cancelaciones', monto: r.total_cancelaciones })

      return {
        tipo: 'ticket',
        tienda: this.enterprise,
        folio: this.ultimaVenta.generals ? this.ultimaVenta.generals.invoice : 0,
        fecha: this.ultimaVenta.generals ? this.ultimaVenta.generals.date : '',
        cliente: this.ultimaVenta.rows[0] ? this.ultimaVenta.rows[0].name_client : '',
        atendio: `${this.user.name} ${this.user.last_name_1} ${this.user.last_name_2}`,
        items: this.ultimaVenta.rows.map((v) => ({
          codigo: v.barcode,
          descripcion: v.product,
          cantidad: v.quantity,
          precioUnit: v.precio,
          descuentoPct: v.discount_percentage,
          total: v.total
        })),
        totalProductos: totalVentaRaw,
        descuento: descuentoRaw,
        total: totalRaw,
        abonos: r.totalAbonos,
        extras,
        pagos,
        telefonos: (this.footer.phones || []).map((p) => p.phone),
        footer: this.footer.textoFooter
      }
    },

    async verifyStatusAbono (abonos) {
      const request = {
        abonos: abonos,
        id_empresa: this.user.enterprise_id
      }
      await axiosAdelaService.post('/verifyStatusAbono', request)
    },

    async getFooterTicket () {
      const request = {
        enterprise_id: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getFooterTicket', request)
      if (response.status === 200) {
        this.footer = response.data
      }
    }
  }
}
</script>
